<template>
  <div class="container">
    <div class="box">
      <div class="title">
        <img src="../../assets/images/keyboard.png" />
        <span>请输入数值</span>
      </div>
      <div class="inputBox">
        <span class="label">年龄：</span>
        <van-field class="input" type="number" v-model="Age" placeholder="请输入年龄（18-100）" />
      </div>
      <div class="inputBox">
        <span class="label">%FEV1：</span>
        <van-field class="input" type="text" v-model="FEV1" right-icon="arrow-down" readonly placeholder="请选择" @click="showFEV1Picker = true" />
        <van-popup v-model="showFEV1Picker" round position="bottom" :style="{ height: '50%' }">
          <van-picker
            show-toolbar
            :columns="FEV1Columns"
            value-key="name"
            @cancel="showFEV1Picker = false"
            @confirm="onFEV1Confirm"
          />
        </van-popup>
      </div>
      <div class="inputBox">
        <span class="label">吸烟史：</span>
        <van-field class="input" type="text" v-model="SmokingHistory" right-icon="arrow-down" readonly placeholder="请选择" @click="showSmokingHistoryPicker = true" />
        <van-popup v-model="showSmokingHistoryPicker" round position="bottom" :style="{ height: '50%' }">
          <van-picker
            show-toolbar
            :columns="SmokingHistoryColumns"
            value-key="name"
            @cancel="showSmokingHistoryPicker = false"
            @confirm="onSmokingHistoryConfirm"
          />
        </van-popup>
      </div>
      <div class="inputBox">
        <span class="label">手术类型：</span>
        <van-field class="input" type="text" v-model="OperationType" right-icon="arrow-down" readonly placeholder="请选择" @click="showOperationTypePicker = true" />
        <van-popup v-model="showOperationTypePicker" round position="bottom" :style="{ height: '50%' }">
          <van-picker
            show-toolbar
            :columns="OperationTypeColumns"
            value-key="name"
            :default-index="1"
            @cancel="showOperationTypePicker = false"
            @confirm="onOperationTypeConfirm"
          />
        </van-popup>
      </div>
      <div class="inputReadonlyBox">
        <span class="label">手术方式：</span>
        <van-field class="input" type="text" readonly placeholder="VATS/RATS" />
      </div>
      <div class="btn" @click="compute">计算</div>
    </div>
    <div class="box">
      <div class="title">
        <img src="../../assets/images/eye_red.png" />
        <span>计算结果</span>
      </div>
      <div class="inputBox">
        <span class="info">估计的PAL发生率Pi：<span class="number">{{ result }}</span></span>
      </div>
    </div>
    <div class="References">
      <p>参考文献：</p>
      <p>1.Attaar A, Tam V, Nason KS. Risk Factors for Prolonged Air Leak After Pulmonary Resection: A Systematic Review and Meta-analysis. Ann Surg. 2020 May;271(5):834-844.</p>
      <p>2.Zheng Q, Ge L, Zhou J, Zhang Y, Lyu M, Chen C, Wang T, Liu L. Risk factors for prolonged air leak after pulmonary surgery: A systematic review and meta-analysis. Asian J Surg. 2022 Nov;45(11):2159-2167.</p>
      <p>3.Jin R, Zheng Y, Gao T, Zhang Y, Wang B, Hang J, Li H. A nomogram for preoperative prediction of prolonged air leak after pulmonary malignancy resection. Transl Lung Cancer Res. 2021 Aug;10(8):3616-3626.</p>
    </div>
    <div class="statement">
      声明：该预测工具是基于已发表文献综合分析后生成的，受到研究纳入患者人群特性和规模、研究时间等多种因素的局限，使得其在外推时需审慎解释预测结果。尚有未纳入本工具的其他因素，也可能对结果产生重大影响，从而产生偏差。本预测工具仅供参考，不能代替临床决策。本预测工具无意代替卫生医疗专业人员的医学判断并且亦无意作为可以信赖的建议。
      <p class="crcode">018012-250827</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComputeTool",
  data() {
    return {
      unionid: '',
      Age: '',
      FEV1: '',
      FEV1Value: null,
      showFEV1Picker: false,
      FEV1Columns: [{
        name: '≥0.8',
        value: 0
      }, {
        name: '0.5~0.8',
        value: 0.18
      }, {
        name: '＜0.5',
        value: 1.04
      }],
      SmokingHistory: '',
      SmokingHistoryValue: null,
      showSmokingHistoryPicker: false,
      SmokingHistoryColumns: [{
        name: '从不',
        value: 0
      }, {
        name: '有吸烟史',
        value: 0.43
      }],
      OperationType: '',
      OperationTypeValue: null,
      showOperationTypePicker: false,
      OperationTypeColumns: [{
        name: '肺叶',
        value: 0
      }, {
        name: '肺段',
        value: -1.05
      }, {
        name: '楔形',
        value: -2.11
      }, {
        name: '多叶切除术',
        value: 1.11
      }],
      result: '0.00%'
    }
  },
  computed: {
    source() {
      return this.$route.query.source;
    }
  },
  created() {
    let unionid = sessionStorage.getItem('unionid');
    if (!unionid) {
      this.$router.push('/HubAuthorize');
    } else {
      this.unionid = unionid;
      this.accessRecord();
    }
  },
  methods: {
    accessRecord() {
      this.$axios.post("/Api/Api/Web/ComputeToolLog/AddCTL", {
        Unionid: this.unionid,
        UserSource: this.source
      }).then((res) => {});
    },
    onFEV1Confirm(val) {
      this.FEV1 = val.name;
      this.FEV1Value = val.value;
      this.showFEV1Picker = false;
    },
    onSmokingHistoryConfirm(val) {
      this.SmokingHistory = val.name;
      this.SmokingHistoryValue = val.value;
      this.showSmokingHistoryPicker = false;
    },
    onOperationTypeConfirm(val) {
      this.OperationType = val.name;
      this.OperationTypeValue = val.value;
      this.showOperationTypePicker = false;
    },
    compute() {
      if(!this.Age) {
        this.$toast('请输入年龄！');
        return false;
      } else {
        if(this.Age <18 || this.Age > 100) {
          this.$toast('年龄超出范围（18-100）');
          return false;
        }
      }
      
      if(this.FEV1Value == null) {
        this.$toast('请选择%FEV1！');
        return false;
      }

      if(this.SmokingHistoryValue == null) {
        this.$toast('请选择吸烟史！');
        return false;
      }

      if(this.OperationTypeValue == null) {
        this.$toast('请选择手术类型！');
        return false;
      }

      let z = 0.02 * this.Age + this.FEV1Value + this.SmokingHistoryValue + this.OperationTypeValue - 0.5 - 3.46;
      let result = 1/(1+Math.exp(-z)) * 100;
      this.result = result.toFixed(2) + '%';
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
  padding: 20px 0;
  box-sizing: border-box;
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  .box {
    margin: 20px 15px;
    border: 1px solid #7e7e7e;
    padding: 10px;
    border-radius: 6px;
    background-color: #FCFCFC;
    .title {
      display: flex;
      align-items: center;
      img {
        width: 26px;
        margin-right: 4px;
      }
      span {
        font-size: 16px;
        font-weight: bold;
      }
    }
    .inputBox {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 10px 0;
      .label {
        display: inline-block;
        width: 80px;
        color: #333333;
        text-align: right;
      }
      .input {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        border:1px solid #7e7e7e;
        width: 100px;
        height: 32px;
        border-radius: 3px;
        padding: 0 8px;
        box-sizing: border-box;
      }
      .info {
        color: #333333;
        margin: 5px 20px;
        .number {
          font-size: 18px;
          color: #E91813;
          font-weight: bold;
        }
      }
    }
    .inputReadonlyBox {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 10px 0;
      .label {
        display: inline-block;
        width: 80px;
        color: #333333;
        text-align: right;
      }
      .input {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        border:1px solid #CCCCCC;
        width: 100px;
        height: 32px;
        border-radius: 3px;
        padding: 0 8px;
        box-sizing: border-box;
      }
    }
    .btn {
      font-size: 14px;
      text-align: center;
      width: 100px;
      height: 35px;
      line-height: 35px;
      background-color: #E91813;
      color: #FFFFFF;
      margin: 16px auto 6px;
      border-radius: 6px;
    }
  }
  .References {
    padding: 0px 15px 115px;
    background-color: #FDFDFD;
    box-sizing: border-box;
    p {
      font-size: 11px;
      color: #4A4A4A;
      // -webkit-text-size-adjust: none !important;
      // text-size-adjust: none !important;
    }
  }
  .statement {
    position: fixed;
    left: 0;
    bottom: 0;
    font-size: 11px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #FFFFFF;
    padding: 6px 10px;
    // -webkit-text-size-adjust: none !important;
    // text-size-adjust: none !important;
    .crcode {
      text-align: right;
      font-size: 11px;
    }
  }
}
</style>